export function common() {
	document.addEventListener('DOMContentLoaded', () => {
		const toggleTriggerEls = document.querySelectorAll('.js-toggle-trigger')
		if (toggleTriggerEls) {
			toggleTriggerEls.forEach((toggleTriggerEl) => {
				toggleTriggerEl.addEventListener('click', () => {
					const toggleEl = toggleTriggerEl.closest('.js-toggle')
					if (toggleEl) {
						toggleEl.classList.toggle('active')
					}
				})
			})
		}
	})
}
